import React from 'react';
import { isMobile } from 'react-device-detect';
import { usePreferences } from '../Preferences/PreferencesContext';
import { getThemeColors } from '../../helpers/themeColors';

const SPACING = {
  containerMarginTop: 40,
  containerPaddingVertical: 16,
  containerPaddingHorizontalDesktop: 20,
  containerPaddingHorizontalMobile: 12,
  borderRadius: 6,
};

const FONT = {
  body: 13,
  bodyLineHeight: 1.7,
};

const buildColors = (theme) => {
  const t = getThemeColors(theme);
  return {
    text: t.textFaint,
    link: t.accentPrimary,
    border: t.borderPrimary,
    background: t.backgroundSecondary,
  };
};

const staticContainerStyle = {
  marginTop: SPACING.containerMarginTop,
  borderRadius: SPACING.borderRadius,
};

const RulesDisclaimer = () => {
  const { preferences } = usePreferences();
  const COLORS = buildColors(preferences.theme);

  const containerStyle = {
    ...staticContainerStyle,
    padding: `${SPACING.containerPaddingVertical}px ${isMobile ? SPACING.containerPaddingHorizontalMobile : SPACING.containerPaddingHorizontalDesktop}px`,
    border: `1px solid ${COLORS.border}`,
    backgroundColor: COLORS.background,
  };

  const textStyle = {
    fontSize: FONT.body,
    lineHeight: FONT.bodyLineHeight,
    color: COLORS.text,
    margin: 0,
  };

  const linkStyle = {
    color: COLORS.link,
  };

  return (
    <div style={containerStyle}>
      <p style={textStyle}>
        Rules information on CollectNDeck is provided for convenience and reference only.
        While we aim for accuracy, we are not responsible for any gameplay losses or disputes
        arising from errors or omissions in the rules content displayed here.
        Magic: The Gathering rules are owned and maintained by Wizards of the Coast LLC.
        For the official and authoritative rules, refer to the{' '}
        <a
          href="https://magic.wizards.com/en/rules"
          target="_blank"
          rel="noreferrer"
          style={linkStyle}
        >
          Magic: The Gathering Comprehensive Rules
        </a>
        {' '}on the Wizards of the Coast website.
      </p>
    </div>
  );
};

export default RulesDisclaimer;
